import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Flex,
  Heading,
  Select,
  Text,
  TextField,
} from '@chatsdet/ui';

type OrgProperty = { id: string; name: string };

type AzureDevopsTagTriggerCardProps = {
  properties: OrgProperty[];
  tagTriggerLabel: string;
  tagTriggerPropertyId: string | null;
  isDirty: boolean;
  isSaving: boolean;
  onTagTriggerLabelChange: (label: string) => void;
  onTagTriggerPropertyChange: (propertyId: string | null) => void;
  onSave: () => void;
};

export function AzureDevopsTagTriggerCard({
  properties,
  tagTriggerLabel,
  tagTriggerPropertyId,
  isDirty,
  isSaving,
  onTagTriggerLabelChange,
  onTagTriggerPropertyChange,
  onSave,
}: AzureDevopsTagTriggerCardProps) {
  return (
    <Card padding="lg">
      <CardHeader>
        <Heading level={3}>Tag-Triggered Runs</Heading>
        <Text size="sm" className="text-muted-foreground mt-1">
          Adding this tag to a work item in Azure DevOps starts an ad-hoc run.
        </Text>
      </CardHeader>
      <CardContent>
        <Flex direction="column" gap="lg">
          <div>
            <Text size="sm" className="font-medium mb-1.5">
              Trigger Tag
            </Text>
            <TextField
              aria-label="Tag trigger label"
              value={tagTriggerLabel}
              placeholder="e.g. canary-run"
              onChange={onTagTriggerLabelChange}
            />
          </div>

          <div>
            <Text size="sm" className="font-medium mb-1.5">
              Target Application
            </Text>
            {properties.length <= 1 ? (
              <Text size="sm" className="text-muted-foreground">
                {properties.length === 1
                  ? `Will run on "${properties[0]!.name}" (the only application in this organization).`
                  : 'No applications configured yet.'}
              </Text>
            ) : (
              <>
                <Select
                  aria-label="Tag trigger target application"
                  selectedKey={tagTriggerPropertyId}
                  items={properties.map((p) => ({ id: p.id, label: p.name }))}
                  placeholder="Select an application..."
                  onSelectionChange={(key) => onTagTriggerPropertyChange((key as string) ?? null)}
                />
                {!tagTriggerPropertyId && (
                  <Text size="sm" className="text-muted-foreground mt-1.5">
                    Pick an application — tagged work items are skipped until one is set.
                  </Text>
                )}
              </>
            )}
          </div>

          <Flex gap="sm">
            <Button variant="primary" size="sm" onPress={onSave} isDisabled={!isDirty || isSaving}>
              {isSaving ? 'Saving...' : 'Save Tag Trigger'}
            </Button>
          </Flex>
        </Flex>
      </CardContent>
    </Card>
  );
}
